import { Store } from 'vuex'
import { AxiosError, AxiosInstance } from 'axios'
import { Router } from 'vue-router'
import { instanceAuth } from '@/model/api/apibase'
import { State as StoreState } from '@/store/index'
import API_URL from '@/model/api/apiUrlType'
import { ErrorResponse } from '@/model/api/error/erroResponse'
import { useApiError } from '@/model/api/error/apiError'
import { ErrorMsgState } from '@/model/components/common/message/errorMessage'
import { NormalMsgState, convertData } from '@/model/components/common/message/normalMessage'
import { PassUpdateState } from '@/model/components/users/userPasswordState'

// リクエストデータ
type RequestData = {
  // 現在パスワード
  oldPassword: string
  // 新パスワード
  newPassword: string
  // 新パスワード(確認用)
  newPasswordConfirm: string
}

/**
 * ユーザーパスワードの関数を返す
 * @param router vueRouter
 * @param store vuex
 * @returns ユーザーパスワードの関数
 */
const useUserPassword = (router: Router, store: Store<StoreState>) => {
  // API通信インスタンス
  const instance: AxiosInstance | undefined = instanceAuth(router, store)

  /**
   * パスワード更新処理のAPIを実施
   * @param state 画面データ
   * @param error エラーメッセージ状態
   * @param normal 正常メッセージ状態
   */
  const update = async (state: PassUpdateState, error: ErrorMsgState, normal: NormalMsgState) => {
    // リクエストデータ設定
    const request: RequestData = {
      oldPassword: state.nowpassword,
      newPassword: state.newpassword,
      newPasswordConfirm: state.newpasswordConfirm,
    }
    // 認証後のaxiosインスタンス取得
    const obj = instance
    await obj
      .patch(
        API_URL.USERS.PASSEDIT, // URL
        request // リクエストデータ
      )
      .then(() => {
        // 更新成功時は正常メッセージを設定する
        convertData('body.main.edit.password.normal.message', normal)
      })
      .catch(async (e: AxiosError<ErrorResponse>) => {
        // 異常時はエラーメッセージを設定する
        await useApiError().setbaseError(e, error)
      })
  }
  return {
    instance,
    update,
  }
}

export {
  useUserPassword, //
}
